export const AUTH_STORAGE_KEY = "auth-storage";

export function readPersistedAuthTokens(): {
  accessToken: string | null;
  refreshToken: string | null;
} {
  if (typeof window === "undefined") {
    return { accessToken: null, refreshToken: null };
  }

  const storedAuth = window.localStorage.getItem(AUTH_STORAGE_KEY);
  if (!storedAuth) {
    return { accessToken: null, refreshToken: null };
  }

  try {
    const parsed = JSON.parse(storedAuth);
    const persistedState = parsed?.state ?? parsed;
    return {
      accessToken: persistedState?.accessToken ?? null,
      refreshToken: persistedState?.refreshToken ?? null,
    };
  } catch {
    return { accessToken: null, refreshToken: null };
  }
}

export function persistAuthTokens(
  accessToken: string | null,
  refreshToken: string | null,
): void {
  if (typeof window === "undefined") {
    return;
  }

  if (!accessToken || !refreshToken) {
    window.localStorage.removeItem(AUTH_STORAGE_KEY);
    return;
  }

  window.localStorage.setItem(
    AUTH_STORAGE_KEY,
    JSON.stringify({
      state: {
        accessToken,
        refreshToken,
      },
      version: 0,
    }),
  );
}
